function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M604.5,663.9l-26.4,21.5c-1.8,1.4-4.4,1.2-5.8-0.6l0,0c-1.4-1.8-1.2-4.4,0.6-5.8l26.4-21.5c1.8-1.4,4.4-1.2,5.8,0.6l0,0 C606.5,659.8,606.2,662.4,604.5,663.9z"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M736.1,793.6l-53.4,8.2c-1.6,0.2-3.2-0.4-4.2-1.6c-1-1.2-1.3-2.9-0.7-4.3l19.8-48.9c0.6-1.5,1.9-2.5,3.5-2.7 s3.2,0.4,4.2,1.6l33.6,40.7c1,1.2,1.3,2.9,0.7,4.3C739,792.3,737.7,793.3,736.1,793.6z M689,792l38-5.8l-23.9-29L689,792z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M218.7,734.5c-17.2,0-31.2-14-31.2-31.2s14-31.2,31.2-31.2s31.2,14,31.2,31.2S235.9,734.5,218.7,734.5z M218.7,682.1 c-11.7,0-21.3,9.5-21.3,21.3c0,11.7,9.5,21.3,21.3,21.3c11.7,0,21.3-9.5,21.3-21.3S230.4,682.1,218.7,682.1z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M577.5,88.4l20.9,5.3c3.7,0.9,7.5-1.3,8.4-5l0,0c0.9-3.7-1.3-7.5-5-8.4L580.9,75l5.3-20.9c0.9-3.7-1.3-7.5-5-8.4l0,0 c-3.7-0.9-7.5,1.3-8.4,5l-5.3,20.9l-20.9-5.3c-3.7-0.9-7.5,1.3-8.4,5l0,0c-0.9,3.7,1.3,7.5,5,8.4l20.9,5.3l-5.3,20.9 c-0.9,3.7,1.3,7.5,5,8.4l0,0c3.7,0.9,7.5-1.3,8.4-5L577.5,88.4z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  id: "_x32_OyNwC.tif"
}, React.createElement("g", null, React.createElement("path", {
  d: "M121.2,729.9c-2.5-0.9-4.6-2.9-6.1-5.9c-0.3-0.6-0.6-1.3-0.8-1.9c-0.4-0.8-0.7-1.6-1.1-2.3c-1.5-2.6-4.6-3.7-7.5-2.7 c-0.9,0.3-1.7,0.8-2.6,1.2c-0.3,0.1-0.6,0.3-0.8,0.4c-3.3,1.7-6.4,2-9,1.1c-2.7-1-4.9-3.2-6.4-6.7c-0.2-0.4-0.3-0.8-0.5-1.2 c-0.3-0.8-0.7-1.5-1-2.2c-1.5-2.8-4.7-3.9-7.6-2.8c-0.8,0.3-1.5,0.7-2.3,1.1c-0.8,0.4-1.5,0.8-2.4,1.2c-5.3,2.3-10.5,0.5-13.3-4.6 c-0.5-1-0.9-1.9-1.3-2.8c-0.4-0.8-0.7-1.6-1.1-2.3c-1-1.8-0.4-4,1.4-5.1c1.8-1,4-0.4,5.1,1.4c0.6,1.1,1,2.1,1.5,3 c0.3,0.8,0.7,1.5,1,2.2c0.9,1.7,2.1,2.1,3.9,1.3c0.6-0.3,1.3-0.6,1.9-0.9c1-0.5,2-1,3.1-1.5c6.4-2.4,13.4,0.1,16.7,6.1 c0.6,1,1,2,1.4,2.9c0.1,0.3,0.3,0.7,0.4,1c0.7,1.5,1.4,2.5,2.1,2.7l0,0c0.7,0.2,1.8,0,3.2-0.7c0.3-0.1,0.5-0.3,0.8-0.4 c1-0.5,2.2-1.1,3.5-1.6c6.3-2.3,13.2,0.2,16.4,6c0.6,1.1,1,2.1,1.5,3.1c0.2,0.5,0.5,1.1,0.7,1.6c1.1,2.3,2.3,2.8,4.6,1.7 c0.4-0.2,0.8-0.4,1.3-0.7c1.2-0.7,2.6-1.4,4.5-1.8c2-0.4,4,0.8,4.4,2.8s-0.8,4-2.8,4.4c-0.8,0.2-1.6,0.6-2.5,1.1 c-0.5,0.3-1.1,0.6-1.7,0.9C126.6,730.6,123.7,730.8,121.2,729.9z"
})));

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M96,606.8l-9.9-37.5c-0.3-1.1,0-2.3,0.8-3.1s2-1.1,3.1-0.8l37.4,10.1c1.1,0.3,2,1.2,2.3,2.3s0,2.3-0.8,3.1l-27.5,27.3 c-0.8,0.8-2,1.1-3.1,0.8C97.1,608.8,96.3,607.9,96,606.8z M93.7,573.1l7.1,26.7l19.6-19.4L93.7,573.1z"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M313.4,757.7l4.9-4.9c0.9-0.9,0.9-2.3,0-3.2l0,0c-0.9-0.9-2.3-0.9-3.2,0l-4.9,4.9l-4.9-4.9c-0.9-0.9-2.3-0.9-3.2,0l0,0 c-0.9,0.9-0.9,2.3,0,3.2l4.9,4.9l-4.9,4.9c-0.9,0.9-0.9,2.3,0,3.2l0,0c0.9,0.9,2.3,0.9,3.2,0l4.9-4.9l4.9,4.9c0.9,0.9,2.3,0.9,3.2,0 l0,0c0.9-0.9,0.9-2.3,0-3.2L313.4,757.7z"
});

var _ref8 =
/*#__PURE__*/
React.createElement("g", {
  id: "_x32_OyNwC.tif_1_"
}, React.createElement("g", null, React.createElement("path", {
  d: "M348.3,282.2c-1.4-0.9-2.4-2.5-2.8-4.5c-0.1-0.4-0.2-0.9-0.2-1.3c-0.1-0.6-0.2-1.1-0.3-1.6c-0.5-1.8-2.2-3-4.1-2.8 c-0.6,0.1-1.2,0.2-1.8,0.4c-0.2,0-0.4,0.1-0.6,0.1c-2.3,0.5-4.2,0.3-5.7-0.7s-2.5-2.7-2.9-5c0-0.3-0.1-0.5-0.1-0.8 c-0.1-0.5-0.2-1-0.3-1.5c-0.5-1.9-2.3-3.1-4.2-2.8c-0.5,0.1-1,0.2-1.6,0.3c-0.5,0.1-1.1,0.3-1.6,0.3c-3.6,0.6-6.5-1.3-7.4-4.8 c-0.2-0.7-0.3-1.3-0.4-1.9s-0.2-1.1-0.3-1.6c-0.3-1.2,0.4-2.5,1.6-2.9c1.2-0.3,2.5,0.4,2.9,1.6c0.2,0.7,0.3,1.4,0.4,2.1 c0.1,0.5,0.2,1,0.3,1.5c0.3,1.2,1,1.6,2.1,1.4c0.4-0.1,0.9-0.2,1.3-0.3c0.7-0.2,1.3-0.3,2.1-0.4c4.2-0.5,8.2,2.1,9.3,6.2 c0.2,0.7,0.3,1.3,0.4,2c0,0.2,0.1,0.5,0.1,0.7c0.2,1,0.5,1.7,0.9,2l0,0c0.4,0.3,1.1,0.3,2.1,0c0.2,0,0.4-0.1,0.5-0.1 c0.7-0.2,1.5-0.4,2.4-0.5c4.2-0.4,8,2.1,9.1,6.2c0.2,0.7,0.3,1.4,0.4,2.1c0.1,0.4,0.1,0.7,0.2,1.1c0.3,1.6,1,2,2.6,1.7 c0.3-0.1,0.6-0.1,0.9-0.2c0.9-0.2,1.8-0.5,3-0.4c1.3,0,2.3,1.1,2.3,2.4s-1.1,2.3-2.4,2.3c-0.5,0-1,0.1-1.7,0.3 c-0.4,0.1-0.7,0.2-1.2,0.3C351.5,283.5,349.7,283.1,348.3,282.2z"
})));

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M101.6,515.9l-55.7-11.3c-3.7-0.8-6.2-4.4-5.4-8.2l0,0c0.8-3.7,4.4-6.2,8.2-5.4l55.7,11.3c3.7,0.8,6.2,4.4,5.4,8.2l0,0 C109,514.2,105.3,516.6,101.6,515.9z"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M676.9,470.1l-6.7-25.1c-0.2-0.7,0-1.5,0.6-2.1c0.5-0.5,1.3-0.8,2.1-0.6l25.1,6.8c0.7,0.2,1.3,0.8,1.5,1.5s0,1.5-0.6,2.1 L680.5,471c-0.5,0.5-1.3,0.8-2.1,0.6C677.6,471.5,677.1,470.9,676.9,470.1z M675.3,447.5l4.7,17.9l13.1-13L675.3,447.5z"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M26.4,612.7l4.9-4.9c0.9-0.9,0.9-2.3,0-3.2l0,0c-0.9-0.9-2.3-0.9-3.2,0l-4.9,4.9l-4.9-4.9c-0.9-0.9-2.3-0.9-3.2,0l0,0 c-0.9,0.9-0.9,2.3,0,3.2l4.9,4.9l-4.9,4.9c-0.9,0.9-0.9,2.3,0,3.2l0,0c0.9,0.9,2.3,0.9,3.2,0l4.9-4.9l4.9,4.9c0.9,0.9,2.3,0.9,3.2,0 l0,0c0.9-0.9,0.9-2.3,0-3.2L26.4,612.7z"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M137.3,825.6c-4.3,0-7.7-3.5-7.7-7.7c0-4.3,3.5-7.7,7.7-7.7s7.7,3.5,7.7,7.7C145,822.2,141.5,825.6,137.3,825.6z M137.3,812.6c-2.9,0-5.3,2.4-5.3,5.3s2.4,5.3,5.3,5.3c2.9,0,5.3-2.4,5.3-5.3S140.2,812.6,137.3,812.6z"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M50.5,828.8l-32.1-46.9c-2.2-3.1-1.3-7.5,1.8-9.6l0,0c3.1-2.2,7.5-1.3,9.6,1.8L61.9,821c2.2,3.1,1.3,7.5-1.8,9.6l0,0 C56.9,832.8,52.6,832,50.5,828.8z"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "M21.7,42.7l38.4,4.9c1.1,0.1,2.1,0.9,2.6,2c0.4,1.1,0.3,2.3-0.4,3.2L38.8,83.6c-0.7,0.9-1.8,1.4-3,1.2 c-1.1-0.1-2.1-0.9-2.6-2l-15-35.7c-0.4-1.1-0.3-2.3,0.4-3.2C19.4,43,20.5,42.5,21.7,42.7z M53.8,53.3l-27.3-3.5l10.7,25.4L53.8,53.3 z"
});

var _ref15 =
/*#__PURE__*/
React.createElement("g", {
  id: "_x32_OyNwC.tif_2_"
}, React.createElement("g", null, React.createElement("path", {
  d: "M449.3,137c0.9-2.5,2.9-4.6,5.9-6.1c0.6-0.3,1.3-0.6,1.9-0.8c0.8-0.4,1.6-0.7,2.3-1.1c2.6-1.5,3.7-4.6,2.7-7.5 c-0.3-0.9-0.8-1.7-1.2-2.6c-0.1-0.3-0.3-0.6-0.4-0.8c-1.7-3.3-2-6.4-1.1-9c1-2.7,3.2-4.9,6.7-6.4c0.4-0.2,0.8-0.3,1.2-0.5 c0.8-0.3,1.5-0.7,2.2-1c2.8-1.5,3.9-4.7,2.8-7.6c-0.3-0.8-0.7-1.5-1.1-2.3s-0.8-1.5-1.2-2.4c-2.3-5.3-0.5-10.5,4.6-13.3 c1-0.5,1.9-0.9,2.8-1.3c0.8-0.4,1.6-0.7,2.3-1.1c1.8-1,4-0.4,5.1,1.4c1,1.8,0.4,4-1.4,5.1c-1.1,0.6-2.1,1-3,1.5 c-0.8,0.3-1.5,0.7-2.2,1c-1.7,0.9-2.1,2.1-1.3,3.9c0.3,0.6,0.6,1.3,0.9,1.9c0.5,1,1,2,1.5,3.1c2.4,6.4-0.1,13.4-6.1,16.7 c-1,0.6-2,1-2.9,1.4c-0.3,0.1-0.7,0.3-1,0.4c-1.5,0.7-2.5,1.4-2.7,2.1l0,0c-0.2,0.7,0,1.8,0.7,3.2c0.1,0.3,0.3,0.5,0.4,0.8 c0.5,1,1.1,2.2,1.6,3.5c2.3,6.3-0.2,13.2-6,16.4c-1.1,0.6-2.1,1-3.1,1.5c-0.5,0.2-1.1,0.5-1.6,0.7c-2.3,1.1-2.8,2.3-1.7,4.6 c0.2,0.4,0.4,0.8,0.7,1.3c0.7,1.2,1.4,2.6,1.8,4.5c0.4,2-0.8,4-2.8,4.4s-4-0.8-4.4-2.8c-0.2-0.8-0.6-1.6-1.1-2.5 c-0.3-0.5-0.6-1.1-0.9-1.7C448.6,142.4,448.4,139.5,449.3,137z"
})));

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  d: "M703.4,159.7l37.5-9.9c1.1-0.3,2.3,0,3.1,0.8s1.1,2,0.8,3.1l-10.1,37.4c-0.3,1.1-1.2,2-2.3,2.3s-2.3,0-3.1-0.8L702,165.1 c-0.8-0.8-1.1-2-0.8-3.1C701.4,160.9,702.3,160,703.4,159.7z M737.1,157.5l-26.7,7.1l19.4,19.6L737.1,157.5z"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  d: "M696.5,625.1l4.9,4.9c0.9,0.9,2.3,0.9,3.2,0l0,0c0.9-0.9,0.9-2.3,0-3.2l-4.9-4.9l4.9-4.9c0.9-0.9,0.9-2.3,0-3.2l0,0 c-0.9-0.9-2.3-0.9-3.2,0l-4.9,4.9l-4.9-4.9c-0.9-0.9-2.3-0.9-3.2,0l0,0c-0.9,0.9-0.9,2.3,0,3.2l4.9,4.9l-4.9,4.9 c-0.9,0.9-0.9,2.3,0,3.2l0,0c0.9,0.9,2.3,0.9,3.2,0L696.5,625.1z"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  d: "M556.5,190c0-8.7,7.1-15.7,15.7-15.7c8.7,0,15.7,7.1,15.7,15.7s-7.1,15.7-15.7,15.7S556.5,198.7,556.5,190z M583,190 c0-5.9-4.8-10.7-10.7-10.7s-10.7,4.8-10.7,10.7s4.8,10.7,10.7,10.7S583,195.9,583,190z"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  d: "M421.5,41.1l4.9,4.9c0.9,0.9,2.3,0.9,3.2,0l0,0c0.9-0.9,0.9-2.3,0-3.2l-4.9-4.9l4.9-4.9c0.9-0.9,0.9-2.3,0-3.2l0,0 c-0.9-0.9-2.3-0.9-3.2,0l-4.9,4.9l-4.9-4.9c-0.9-0.9-2.3-0.9-3.2,0l0,0c-0.9,0.9-0.9,2.3,0,3.2l4.9,4.9l-4.9,4.9 c-0.9,0.9-0.9,2.3,0,3.2l0,0c0.9,0.9,2.3,0.9,3.2,0L421.5,41.1z"
});

var _ref20 =
/*#__PURE__*/
React.createElement("path", {
  d: "M368.5,135c0-4.3,3.5-7.7,7.7-7.7s7.7,3.5,7.7,7.7s-3.5,7.7-7.7,7.7S368.5,139.3,368.5,135z M381.5,135 c0-2.9-2.4-5.3-5.3-5.3s-5.3,2.4-5.3,5.3c0,2.9,2.4,5.3,5.3,5.3C379.2,140.3,381.5,137.9,381.5,135z"
});

var _ref21 =
/*#__PURE__*/
React.createElement("path", {
  d: "M654.4,223.8l19.7,53.4c1.3,3.6-0.5,7.6-4.1,8.9l0,0c-3.6,1.3-7.6-0.5-8.9-4.1l-19.7-53.4c-1.3-3.6,0.5-7.6,4.1-8.9l0,0 C649.1,218.3,653.1,220.2,654.4,223.8z"
});

var _ref22 =
/*#__PURE__*/
React.createElement("g", {
  id: "_x32_OyNwC.tif_3_"
}, React.createElement("g", null, React.createElement("path", {
  d: "M651.1,376.4c1.7-0.2,3.4,0.4,5,1.7c0.4,0.3,0.7,0.6,1,0.8c0.4,0.4,0.8,0.7,1.3,1c1.5,1.1,3.6,0.8,5-0.5 c0.4-0.4,0.8-0.9,1.2-1.4c0.1-0.2,0.2-0.3,0.4-0.5c1.4-1.9,3-2.9,4.8-3.1s3.6,0.5,5.5,2c0.2,0.2,0.4,0.3,0.6,0.5 c0.4,0.4,0.8,0.7,1.2,1c1.6,1.1,3.7,0.9,5.1-0.5c0.4-0.4,0.7-0.8,1-1.3c0.3-0.4,0.6-0.9,1-1.3c2.4-2.7,5.8-3.2,8.8-1.1 c0.6,0.4,1.1,0.8,1.5,1.2c0.4,0.4,0.8,0.7,1.3,1c1.1,0.7,1.3,2.2,0.6,3.2c-0.7,1.1-2.2,1.3-3.2,0.6c-0.6-0.4-1.1-0.9-1.7-1.3 c-0.4-0.3-0.8-0.7-1.2-1c-1-0.7-1.8-0.6-2.5,0.3c-0.3,0.3-0.5,0.7-0.8,1.1c-0.4,0.5-0.8,1.1-1.4,1.7c-2.9,3.1-7.6,3.6-11.1,1.2 c-0.6-0.4-1.1-0.8-1.6-1.3c-0.2-0.2-0.4-0.3-0.5-0.5c-0.8-0.7-1.5-1-2-0.9l0,0c-0.5,0.1-1,0.5-1.6,1.3c-0.1,0.1-0.2,0.3-0.3,0.4 c-0.4,0.6-0.9,1.2-1.5,1.9c-2.9,3-7.5,3.5-10.9,1.1c-0.6-0.4-1.2-0.9-1.7-1.3c-0.3-0.2-0.5-0.5-0.8-0.7c-1.3-1-2.1-0.9-3.1,0.3 c-0.2,0.2-0.4,0.5-0.5,0.7c-0.5,0.7-1.1,1.5-2,2.3c-1,0.8-2.5,0.6-3.3-0.4s-0.6-2.5,0.4-3.3c0.4-0.3,0.7-0.8,1.1-1.3 c0.2-0.3,0.4-0.6,0.7-1C647.9,377.4,649.4,376.5,651.1,376.4z"
})));

var _ref23 =
/*#__PURE__*/
React.createElement("path", {
  d: "M505.2,249.3l-18,17.6c-0.5,0.5-1.3,0.7-2,0.5s-1.3-0.8-1.5-1.5l-6.2-24.4c-0.2-0.7,0-1.5,0.6-2c0.5-0.5,1.3-0.7,2-0.5 l24.2,6.8c0.7,0.2,1.3,0.8,1.5,1.5C506,248,505.8,248.8,505.2,249.3z M486.9,261.3l12.8-12.5l-17.2-4.9L486.9,261.3z"
});

var _ref24 =
/*#__PURE__*/
React.createElement("path", {
  d: "M446.7,703.1l-4.9,4.9c-0.9,0.9-0.9,2.3,0,3.2l0,0c0.9,0.9,2.3,0.9,3.2,0l4.9-4.9l4.9,4.9c0.9,0.9,2.3,0.9,3.2,0l0,0 c0.9-0.9,0.9-2.3,0-3.2l-4.9-4.9l4.9-4.9c0.9-0.9,0.9-2.3,0-3.2l0,0c-0.9-0.9-2.3-0.9-3.2,0l-4.9,4.9L445,695 c-0.9-0.9-2.3-0.9-3.2,0l0,0c-0.9,0.9-0.9,2.3,0,3.2L446.7,703.1z"
});

var _ref25 =
/*#__PURE__*/
React.createElement("path", {
  d: "M398.7,247.5c-17.2,0-31.2-14-31.2-31.2s14-31.2,31.2-31.2s31.2,14,31.2,31.2S415.9,247.5,398.7,247.5z M398.7,195.1 c-11.7,0-21.3,9.5-21.3,21.3s9.5,21.3,21.3,21.3c11.7,0,21.3-9.5,21.3-21.3S410.4,195.1,398.7,195.1z"
});

var _ref26 =
/*#__PURE__*/
React.createElement("path", {
  d: "M218.9,403l5.9-35.1c0.2-1,0.9-1.9,1.9-2.3s2.1-0.2,2.9,0.5l27.4,22.6c0.8,0.7,1.2,1.7,1,2.8s-0.9,1.9-1.9,2.3l-33.3,12.5 c-1,0.4-2.1,0.2-2.9-0.5C219.2,405.1,218.8,404,218.9,403z M229.8,373.9l-4.2,25l23.7-8.9L229.8,373.9z"
});

var _ref27 =
/*#__PURE__*/
React.createElement("path", {
  d: "M24.5,433c0-4.3,3.5-7.7,7.7-7.7s7.7,3.5,7.7,7.7s-3.5,7.7-7.7,7.7S24.5,437.3,24.5,433z M37.5,433c0-2.9-2.4-5.3-5.3-5.3 S27,430.1,27,433s2.4,5.3,5.3,5.3S37.5,435.9,37.5,433z"
});

var _ref28 =
/*#__PURE__*/
React.createElement("g", {
  id: "_x32_OyNwC.tif_4_"
}, React.createElement("g", null, React.createElement("path", {
  d: "M598.8,748.7c1.6,0.6,2.9,1.8,3.8,3.7c0.2,0.4,0.4,0.8,0.5,1.2c0.2,0.5,0.4,1,0.7,1.5c0.9,1.6,2.9,2.4,4.7,1.7 c0.5-0.2,1.1-0.5,1.7-0.8c0.2-0.1,0.3-0.2,0.5-0.3c2.1-1,4-1.3,5.7-0.7s3.1,2,4,4.2c0.1,0.2,0.2,0.5,0.3,0.7 c0.2,0.5,0.4,1,0.6,1.4c1,1.7,2.9,2.5,4.8,1.8c0.5-0.2,1-0.4,1.5-0.7c0.5-0.2,1-0.5,1.5-0.7c3.3-1.4,6.6-0.3,8.3,2.9 c0.3,0.6,0.6,1.2,0.8,1.8c0.2,0.5,0.4,1,0.7,1.5c0.6,1.1,0.2,2.5-0.9,3.2c-1.1,0.6-2.5,0.2-3.2-0.9c-0.4-0.7-0.6-1.3-0.9-1.9 c-0.2-0.5-0.4-1-0.6-1.4c-0.6-1-1.3-1.3-2.4-0.8c-0.4,0.2-0.8,0.4-1.2,0.6c-0.6,0.3-1.2,0.6-2,0.9c-4,1.5-8.4-0.1-10.5-3.8 c-0.4-0.6-0.6-1.2-0.9-1.8c-0.1-0.2-0.2-0.4-0.3-0.6c-0.4-0.9-0.9-1.5-1.3-1.7l0,0c-0.4-0.2-1.1,0-2,0.4c-0.2,0.1-0.3,0.2-0.5,0.2 c-0.6,0.3-1.4,0.7-2.2,1c-3.9,1.4-8.3-0.2-10.3-3.8c-0.4-0.7-0.6-1.3-0.9-1.9c-0.1-0.3-0.3-0.7-0.4-1c-0.7-1.5-1.5-1.7-2.9-1.1 c-0.3,0.1-0.5,0.3-0.8,0.4c-0.8,0.4-1.7,0.9-2.8,1.1c-1.3,0.3-2.5-0.5-2.8-1.8s0.5-2.5,1.8-2.8c0.5-0.1,1-0.4,1.6-0.7 c0.3-0.2,0.7-0.4,1.1-0.5C595.4,748.2,597.2,748.1,598.8,748.7z"
})));

var _ref29 =
/*#__PURE__*/
React.createElement("path", {
  d: "M561.5,507.4l26.3-50.4c1.8-3.4,6-4.7,9.3-2.9l0,0c3.4,1.8,4.7,6,2.9,9.3l-26.3,50.4c-1.8,3.4-6,4.7-9.3,2.9l0,0 C561.1,515,559.8,510.8,561.5,507.4z"
});

var _ref30 =
/*#__PURE__*/
React.createElement("path", {
  d: "M520.1,772.7c7.9-3.4,17.1,0.3,20.5,8.2s-0.3,17.1-8.2,20.5s-17.1-0.3-20.5-8.2C508.5,785.3,512.2,776.1,520.1,772.7z M530.4,796.8c5.4-2.3,7.9-8.6,5.6-14c-2.3-5.4-8.6-7.9-14-5.6c-5.4,2.3-7.9,8.6-5.6,14C518.8,796.6,525,799.1,530.4,796.8z"
});

var _ref31 =
/*#__PURE__*/
React.createElement("path", {
  d: "M433.4,615.4l5.7,23.2c0.2,0.7,0,1.4-0.6,1.9c-0.5,0.5-1.2,0.7-1.9,0.5l-22.9-6.7c-0.7-0.2-1.2-0.7-1.4-1.4 c-0.2-0.7,0-1.4,0.6-1.9l17.2-16.5c0.5-0.5,1.2-0.7,1.9-0.5C432.8,614.1,433.3,614.7,433.4,615.4z M434.4,636.1l-4-16.5l-12.3,11.7 L434.4,636.1z"
});

var _ref32 =
/*#__PURE__*/
React.createElement("path", {
  d: "M87.2,209.3l5.4,4.5c0.9,0.8,2.4,0.7,3.2-0.3l0,0c0.8-0.9,0.7-2.4-0.3-3.2l-5.4-4.5l4.5-5.4c0.8-0.9,0.7-2.4-0.3-3.2l0,0 c-0.9-0.8-2.4-0.7-3.2,0.3l-4.5,5.4l-5.4-4.5c-0.9-0.8-2.4-0.7-3.2,0.3l0,0c-0.8,0.9-0.7,2.4,0.3,3.2l5.4,4.5l-4.5,5.4 c-0.8,0.9-0.7,2.4,0.3,3.2l0,0c0.9,0.8,2.4,0.7,3.2-0.3L87.2,209.3z"
});

var _ref33 =
/*#__PURE__*/
React.createElement("g", {
  id: "_x32_OyNwC.tif_5_"
}, React.createElement("g", null, React.createElement("path", {
  d: "M419,452.5c1.5,2.3,1.9,5.2,1.2,8.4c-0.1,0.7-0.3,1.3-0.4,2c-0.2,0.9-0.4,1.6-0.6,2.5c-0.4,2.9,1.3,5.8,4.3,6.7 c0.9,0.2,1.8,0.5,2.8,0.6c0.3,0.1,0.6,0.1,1,0.2c3.7,0.7,6.3,2.2,7.9,4.7c1.6,2.4,1.9,5.5,1,9.2c-0.1,0.4-0.2,0.8-0.3,1.2 c-0.2,0.8-0.4,1.6-0.6,2.3c-0.5,3.1,1.3,5.9,4.4,6.8c0.8,0.2,1.6,0.4,2.6,0.5c0.8,0.2,1.7,0.3,2.6,0.5c5.6,1.4,8.6,6.1,7.7,11.7 c-0.2,1.1-0.4,2.1-0.7,3c-0.2,0.9-0.4,1.7-0.5,2.6c-0.3,2-2.1,3.4-4.2,3.1s-3.4-2.1-3.1-4.2c0.1-1.2,0.4-2.2,0.7-3.3 c0.2-0.8,0.4-1.6,0.6-2.3c0.3-1.9-0.4-2.9-2.3-3.4c-0.6-0.2-1.3-0.3-2.1-0.4c-1.1-0.2-2.2-0.4-3.3-0.7c-6.5-2-10.5-8.3-9.6-15 c0.2-1.1,0.5-2.1,0.6-3.1c0.1-0.3,0.2-0.8,0.3-1c0.4-1.6,0.4-2.8-0.1-3.5l0,0c-0.4-0.6-1.5-1.1-3.1-1.4c-0.3-0.1-0.6-0.1-0.8-0.2 c-1.1-0.2-2.4-0.4-3.8-0.9c-6.4-2-10.2-8.2-9.3-14.8c0.1-1.2,0.5-2.3,0.7-3.3c0.2-0.6,0.3-1.2,0.4-1.6c0.5-2.6-0.1-3.5-2.6-4.1 c-0.4-0.1-1-0.2-1.4-0.3c-1.4-0.3-3-0.5-4.7-1.3c-1.8-0.9-2.6-3.1-1.8-5c0.9-1.8,3.1-2.6,5-1.8c0.7,0.3,1.6,0.5,2.6,0.6 c0.6,0.1,1.3,0.2,1.8,0.3C415.1,448.6,417.5,450.2,419,452.5z"
})));

var _ref34 =
/*#__PURE__*/
React.createElement("path", {
  d: "M199.2,584.5l-3.2,6.2c-0.6,1.1-0.1,2.5,1,3l0,0c1.1,0.6,2.5,0.1,3-1l3.2-6.2l6.2,3.2c1.1,0.6,2.5,0.1,3-1l0,0 c0.6-1.1,0.1-2.5-1-3l-6.2-3.2l3.2-6.2c0.6-1.1,0.1-2.5-1-3l0,0c-1.1-0.6-2.5-0.1-3,1l-3.2,6.2l-6.2-3.2c-1.1-0.6-2.5-0.1-3,1l0,0 c-0.6,1.1-0.1,2.5,1,3L199.2,584.5z"
});

var _ref35 =
/*#__PURE__*/
React.createElement("path", {
  d: "M296.7,606.5c8.3-2.6,17.1,2,19.7,10.2c2.6,8.3-2,17.1-10.2,19.7c-8.3,2.6-17.1-2-19.7-10.2 C283.8,618,288.4,609.2,296.7,606.5z M304.7,631.8c5.6-1.8,8.8-7.8,7-13.5c-1.8-5.6-7.8-8.8-13.5-7c-5.6,1.8-8.8,7.8-7,13.5 C293,630.4,299,633.5,304.7,631.8z"
});

var _ref36 =
/*#__PURE__*/
React.createElement("path", {
  d: "M501,574.4l-3.2,6.2c-0.6,1.1-0.1,2.5,1,3l0,0c1.1,0.6,2.5,0.1,3-1l3.2-6.2l6.2,3.2c1.1,0.6,2.5,0.1,3-1l0,0 c0.6-1.1,0.1-2.5-1-3l-6.2-3.2l3.2-6.2c0.6-1.1,0.1-2.5-1-3l0,0c-1.1-0.6-2.5-0.1-3,1l-3.2,6.2l-6.2-3.2c-1.1-0.6-2.5-0.1-3,1l0,0 c-0.6,1.1-0.1,2.5,1,3L501,574.4z"
});

var _ref37 =
/*#__PURE__*/
React.createElement("path", {
  d: "M325.8,433.4c4.1-1.3,8.4,1,9.7,5c1.3,4.1-1,8.4-5,9.7c-4.1,1.3-8.4-1-9.7-5C319.4,439,321.7,434.6,325.8,433.4z M329.7,445.8c2.8-0.9,4.3-3.8,3.4-6.6c-0.9-2.8-3.8-4.3-6.6-3.4c-2.8,0.9-4.3,3.8-3.4,6.6C323.9,445,326.9,446.6,329.7,445.8z"
});

var _ref38 =
/*#__PURE__*/
React.createElement("path", {
  d: "M418.3,787.5l-38.1,6.9c-1.1,0.2-2.3-0.2-3-1.1c-0.7-0.9-1-2.1-0.6-3.2l13.1-36.5c0.4-1.1,1.3-1.9,2.5-2.1 c1.1-0.2,2.3,0.2,3,1.1l25.1,29.5c0.7,0.9,1,2.1,0.6,3.2C420.4,786.5,419.5,787.3,418.3,787.5z M384.5,787.1l27.1-4.9l-17.8-21 L384.5,787.1z"
});

var _ref39 =
/*#__PURE__*/
React.createElement("path", {
  d: "M594.6,565.6c4.1-1.3,8.4,1,9.7,5c1.3,4.1-1,8.4-5,9.7c-4.1,1.3-8.4-1-9.7-5C588.2,571.2,590.5,566.9,594.6,565.6z M598.5,578c2.8-0.9,4.3-3.8,3.4-6.6c-0.9-2.8-3.8-4.3-6.6-3.4c-2.8,0.9-4.3,3.8-3.4,6.6C592.7,577.3,595.7,578.9,598.5,578z"
});

var _ref40 =
/*#__PURE__*/
React.createElement("path", {
  d: "M588.5,301.4l-5.3-4.5c-0.9-0.8-2.4-0.7-3.2,0.3l0,0c-0.8,0.9-0.7,2.4,0.3,3.2l5.3,4.5l-4.5,5.3c-0.8,0.9-0.7,2.4,0.3,3.2 l0,0c0.9,0.8,2.4,0.7,3.2-0.3l4.5-5.3l5.3,4.5c0.9,0.8,2.4,0.7,3.2-0.3l0,0c0.8-0.9,0.7-2.4-0.3-3.2l-5.3-4.5l4.5-5.3 c0.8-0.9,0.7-2.4-0.3-3.2l0,0c-0.9-0.8-2.4-0.7-3.2,0.3L588.5,301.4z"
});

var _ref41 =
/*#__PURE__*/
React.createElement("path", {
  d: "M226.8,811.4l19.2-14.2c0.6-0.4,1.3-0.5,2-0.2s1.1,0.9,1.2,1.6l2.7,23.7c0.1,0.7-0.2,1.4-0.8,1.8s-1.3,0.5-2,0.2l-21.9-9.5 c-0.7-0.3-1.1-0.9-1.2-1.6C225.9,812.5,226.2,811.8,226.8,811.4z M245.5,802.5l-13.7,10.1l15.6,6.8L245.5,802.5z"
});

var _ref42 =
/*#__PURE__*/
React.createElement("path", {
  d: "M199.5,460.8c3.3,8-0.6,17.2-8.7,20.5c-8,3.3-17.2-0.6-20.5-8.7c-3.3-8,0.6-17.2,8.7-20.5 C187,448.9,196.2,452.7,199.5,460.8z M175,470.7c2.2,5.5,8.5,8.1,14,5.9s8.1-8.5,5.9-14s-8.5-8.1-14-5.9 C175.4,459,172.7,465.3,175,470.7z"
});

var _ref43 =
/*#__PURE__*/
React.createElement("g", {
  id: "_x32_OyNwC.tif_6_"
}, React.createElement("g", null, React.createElement("path", {
  d: "M709.6,24.7c1.2-0.1,2.4,0.3,3.5,1.2c0.2,0.2,0.5,0.4,0.7,0.6c0.3,0.3,0.6,0.5,0.9,0.7c1.1,0.7,2.5,0.6,3.5-0.4 c0.3-0.3,0.5-0.6,0.8-1c0.1-0.1,0.2-0.2,0.2-0.3c1-1.3,2.1-2,3.4-2.2c1.3-0.1,2.5,0.3,3.8,1.4c0.1,0.1,0.3,0.2,0.4,0.4 c0.3,0.2,0.6,0.5,0.8,0.7c1.1,0.8,2.6,0.6,3.5-0.4c0.2-0.3,0.5-0.6,0.7-0.9s0.5-0.6,0.7-0.9c1.7-1.9,4.1-2.2,6.1-0.8 c0.4,0.3,0.7,0.6,1.1,0.9c0.3,0.3,0.6,0.5,0.9,0.7c0.7,0.5,0.9,1.5,0.4,2.3c-0.5,0.7-1.5,0.9-2.3,0.4c-0.4-0.3-0.8-0.6-1.2-0.9 c-0.3-0.2-0.6-0.5-0.8-0.7c-0.7-0.5-1.2-0.4-1.8,0.2c-0.2,0.2-0.4,0.5-0.6,0.7c-0.3,0.4-0.6,0.8-1,1.2c-2.1,2.2-5.3,2.5-7.8,0.8 c-0.4-0.3-0.8-0.6-1.1-0.9c-0.1-0.1-0.2-0.2-0.4-0.3c-0.6-0.5-1-0.7-1.4-0.7l0,0c-0.3,0-0.7,0.4-1.1,0.9c-0.1,0.1-0.2,0.2-0.2,0.3 c-0.3,0.4-0.7,0.9-1.1,1.3c-2,2.1-5.3,2.4-7.7,0.8c-0.4-0.3-0.8-0.6-1.2-0.9c-0.2-0.2-0.4-0.3-0.6-0.5c-0.9-0.7-1.4-0.6-2.1,0.2 c-0.1,0.2-0.2,0.3-0.4,0.5c-0.4,0.5-0.8,1.1-1.4,1.6c-0.7,0.6-1.7,0.4-2.3-0.3c-0.6-0.7-0.4-1.7,0.3-2.3c0.3-0.2,0.5-0.5,0.8-0.9 c0.2-0.2,0.3-0.4,0.5-0.7C707.4,25.5,708.5,24.8,709.6,24.7z"
})));

var _ref44 =
/*#__PURE__*/
React.createElement("path", {
  d: "M649.5,80.1c0-4.3,3.5-7.9,7.9-7.9c4.3,0,7.9,3.5,7.9,7.9s-3.5,7.9-7.9,7.9C653.1,88,649.5,84.5,649.5,80.1z M662.8,80.1 c0-3-2.4-5.4-5.4-5.4s-5.4,2.4-5.4,5.4s2.4,5.4,5.4,5.4C660.4,85.5,662.8,83.1,662.8,80.1z"
});

var _ref45 =
/*#__PURE__*/
React.createElement("path", {
  d: "M320.5,76.8c3.3,8-0.6,17.2-8.7,20.5c-8,3.3-17.2-0.6-20.5-8.7c-3.3-8,0.6-17.2,8.7-20.5S317.2,68.7,320.5,76.8z M296,86.7 c2.2,5.5,8.5,8.1,14,5.9s8.1-8.5,5.9-14s-8.5-8.1-14-5.9C296.4,75,293.7,81.3,296,86.7z"
});

var _ref46 =
/*#__PURE__*/
React.createElement("path", {
  d: "M429.1,409.2l1.9-3.5c0.3-0.6,0.1-1.4-0.5-1.7l0,0c-0.6-0.3-1.4-0.1-1.7,0.5l-1.9,3.5l-3.5-1.9c-0.6-0.3-1.4-0.1-1.7,0.5 l0,0c-0.3,0.6-0.1,1.4,0.5,1.7l3.5,1.9l-1.9,3.5c-0.3,0.6-0.1,1.4,0.5,1.7l0,0c0.6,0.3,1.4,0.1,1.7-0.5l1.9-3.5l3.5,1.9 c0.6,0.3,1.4,0.1,1.7-0.5l0,0c0.3-0.6,0.1-1.4-0.5-1.7L429.1,409.2z"
});

var _ref47 =
/*#__PURE__*/
React.createElement("path", {
  d: "M566.8,383.7c3.8-3.1,9.4-2.6,12.6,1.1c3.1,3.8,2.6,9.4-1.1,12.6c-3.8,3.1-9.4,2.6-12.6-1.1 C562.5,392.5,563,386.9,566.8,383.7z M576.4,395.2c2.6-2.1,2.9-6,0.8-8.6s-6-2.9-8.6-0.8s-2.9,6-0.8,8.6S573.8,397.4,576.4,395.2z"
});

var _ref48 =
/*#__PURE__*/
React.createElement("path", {
  d: "M505.7,374.2l-3.4-13.2c-0.1-0.4,0-0.8,0.3-1.1c0.3-0.3,0.7-0.4,1.1-0.3l13.1,3.7c0.4,0.1,0.7,0.4,0.8,0.8s0,0.8-0.3,1.1 l-9.8,9.6c-0.3,0.3-0.7,0.4-1.1,0.3C506.1,374.9,505.8,374.6,505.7,374.2z M505,362.3l2.4,9.4l6.9-6.8L505,362.3z"
});

var _ref49 =
/*#__PURE__*/
React.createElement("path", {
  d: "M412.3,316.9c4.1-2.8,9.7-1.7,12.5,2.4s1.7,9.7-2.4,12.5s-9.7,1.7-12.5-2.4C407.2,325.3,408.2,319.7,412.3,316.9z M420.8,329.4c2.8-1.9,3.5-5.7,1.6-8.5s-5.7-3.5-8.5-1.6s-3.5,5.7-1.6,8.5S418,331.3,420.8,329.4z"
});

var _ref50 =
/*#__PURE__*/
React.createElement("path", {
  d: "M514.4,448.4l-19.8,10c-0.6,0.3-1.3,0.3-1.8-0.1c-0.6-0.4-0.9-1-0.8-1.6l1.2-22.1c0-0.7,0.4-1.2,1-1.5s1.3-0.3,1.8,0.1 l18.6,12.1c0.6,0.4,0.9,1,0.8,1.6C515.4,447.5,515,448.1,514.4,448.4z M495.9,453.7l14.1-7.1l-13.2-8.6L495.9,453.7z"
});

var _ref51 =
/*#__PURE__*/
React.createElement("path", {
  d: "M525.2,323.4l-29.9-6.1c-2-0.4-3.3-2.4-2.9-4.4l0,0c0.4-2,2.4-3.3,4.4-2.9l29.9,6.1c2,0.4,3.3,2.4,2.9,4.4l0,0 C529.2,322.5,527.2,323.8,525.2,323.4z"
});

var _ref52 =
/*#__PURE__*/
React.createElement("path", {
  d: "M652,138.3l-14.2,11.6c-0.9,0.8-2.4,0.6-3.1-0.3l0,0c-0.8-0.9-0.6-2.4,0.3-3.1l14.2-11.6c0.9-0.8,2.4-0.6,3.1,0.3l0,0 C653.1,136.1,653,137.5,652,138.3z"
});

var _ref53 =
/*#__PURE__*/
React.createElement("path", {
  d: "M9.8,313.1L35,295.9c1.7-1.2,4-0.7,5.2,1l0,0c1.2,1.7,0.7,4-1,5.2L14,319.3c-1.7,1.2-4,0.7-5.2-1l0,0 C7.7,316.6,8.1,314.3,9.8,313.1z"
});

var _ref54 =
/*#__PURE__*/
React.createElement("path", {
  d: "M148,662.5l8.4-29.3c0.6-2,2.6-3.1,4.6-2.5l0,0c2,0.6,3.1,2.6,2.5,4.6l-8.4,29.3c-0.6,2-2.6,3.1-4.6,2.5l0,0 C148.6,666.5,147.4,664.5,148,662.5z"
});

var _ref55 =
/*#__PURE__*/
React.createElement("g", {
  id: "_x32_OyNwC.tif_7_"
}, React.createElement("g", null, React.createElement("path", {
  d: "M342,701.6c0.7-0.9,1.9-1.5,3.3-1.6c0.3,0,0.6-0.1,0.9-0.1c0.4,0,0.8,0,1.1-0.1c1.3-0.2,2.2-1.4,2.2-2.7 c0-0.4-0.1-0.8-0.1-1.3c0-0.1,0-0.3-0.1-0.4c-0.2-1.6,0.1-2.9,0.9-3.9s2-1.5,3.7-1.7c0.2,0,0.4,0,0.6,0c0.4,0,0.7,0,1.1-0.1 c1.4-0.2,2.3-1.4,2.3-2.7c0-0.4-0.1-0.7-0.1-1.1c-0.1-0.4-0.1-0.8-0.1-1.2c-0.2-2.5,1.4-4.4,3.9-4.8c0.5-0.1,0.9-0.1,1.4-0.1 c0.4,0,0.8-0.1,1.1-0.1c0.9-0.2,1.7,0.4,1.9,1.3c0.2,0.9-0.4,1.7-1.3,1.9c-0.5,0.1-1,0.1-1.5,0.2c-0.4,0-0.7,0-1.1,0.1 c-0.8,0.1-1.2,0.6-1.1,1.4c0,0.3,0.1,0.6,0.1,0.9c0.1,0.5,0.1,1,0.1,1.5c0.1,3-2,5.5-5,6c-0.5,0.1-1,0.1-1.4,0.1 c-0.2,0-0.3,0-0.5,0c-0.7,0.1-1.2,0.2-1.4,0.5l0,0c-0.2,0.2-0.3,0.8-0.2,1.4c0,0.1,0,0.3,0,0.4c0.1,0.5,0.1,1.1,0.1,1.7 c0,2.9-2.1,5.4-4.9,5.9c-0.5,0.1-1,0.1-1.5,0.1c-0.3,0-0.5,0-0.7,0.1c-1.1,0.1-1.5,0.6-1.4,1.7c0,0.2,0.1,0.4,0.1,0.6 c0.1,0.6,0.2,1.3,0.1,2.1c-0.1,0.9-0.9,1.5-1.8,1.4s-1.5-0.9-1.4-1.8c0-0.3,0-0.7-0.1-1.2c0-0.3-0.1-0.5-0.1-0.8 C340.9,703.7,341.2,702.5,342,701.6z"
})));

var _ref56 =
/*#__PURE__*/
React.createElement("g", {
  id: "_x32_OyNwC.tif_8_"
}, React.createElement("g", null, React.createElement("path", {
  d: "M672.4,522.3c2.9,1.1,5.1,3.4,6.6,6.9c0.4,0.8,0.6,1.5,0.9,2.1c0.3,1,0.7,1.8,1.3,2.7c1.5,3,5.1,4.3,8.5,3.3 c1-0.3,2-0.8,3.1-1.3c0.3-0.2,0.6-0.3,1.1-0.5c3.8-1.9,7.2-2.2,10.3-1c3.1,1.2,5.4,3.8,7.2,7.8c0.2,0.5,0.4,0.8,0.6,1.3 c0.3,1,0.7,1.8,1.1,2.6c1.7,3.1,5.2,4.5,8.6,3.4c1-0.3,1.8-0.7,2.7-1.3c0.8-0.4,1.7-1,2.7-1.3c6.1-2.4,12-0.4,15.1,5.5 c0.6,1.1,1.1,2.2,1.4,3.2c0.3,1,0.7,1.8,1.3,2.7c1.2,2,0.3,4.6-1.7,5.6c-2,1.2-4.6,0.3-5.6-1.7c-0.6-1.1-1-2.4-1.7-3.5 c-0.4-0.8-0.7-1.8-1.1-2.6c-1-2-2.4-2.4-4.3-1.6c-0.7,0.2-1.4,0.7-2.2,1.1c-1.1,0.5-2.2,1.1-3.7,1.6c-7.2,2.6-15.2-0.5-18.8-7.2 c-0.6-1.1-1.1-2.2-1.5-3.4c-0.2-0.5-0.4-0.8-0.4-1.2c-0.7-1.8-1.6-2.8-2.5-3.1l0,0c-0.9-0.3-2,0-3.6,0.8c-0.2,0.1-0.6,0.3-0.8,0.4 c-1.1,0.6-2.4,1.2-4,1.8c-7.1,2.4-14.9-0.6-18.4-7.2c-0.6-1.1-1.2-2.4-1.7-3.5c-0.3-0.6-0.4-1.2-0.7-1.8c-1.3-2.7-2.6-3.2-5.2-2.1 c-0.5,0.2-1.1,0.5-1.4,0.7c-1.4,0.7-3,1.5-5.1,2c-2.3,0.5-4.5-1.1-5-3.4s1.1-4.5,3.4-5c0.9-0.2,1.8-0.7,2.8-1.2 c0.6-0.3,1.1-0.6,2-1C666.4,521.2,669.6,521,672.4,522.3z"
})));

var _ref57 =
/*#__PURE__*/
React.createElement("path", {
  d: "M665.1,686.9c4.1-2.8,9.7-1.7,12.5,2.4c2.8,4.1,1.7,9.7-2.4,12.5c-4.1,2.8-9.7,1.7-12.5-2.4 C660,695.3,661,689.7,665.1,686.9z M673.6,699.4c2.8-1.9,3.5-5.7,1.6-8.5c-1.9-2.8-5.7-3.5-8.5-1.6c-2.8,1.9-3.5,5.7-1.6,8.5 C667,700.6,670.8,701.3,673.6,699.4z"
});

var _ref58 =
/*#__PURE__*/
React.createElement("path", {
  d: "M506.8,655.7l-3.4-13.2c-0.1-0.4,0-0.8,0.3-1.1c0.3-0.3,0.7-0.4,1.1-0.3l13.1,3.7c0.4,0.1,0.7,0.4,0.8,0.8 c0.1,0.4,0,0.8-0.3,1.1l-9.8,9.6c-0.3,0.3-0.7,0.4-1.1,0.3C507.2,656.4,506.9,656.1,506.8,655.7z M506.1,643.8l2.4,9.4l6.9-6.8 L506.1,643.8z"
});

var _ref59 =
/*#__PURE__*/
React.createElement("path", {
  d: "M415.5,565l-43.3,11.2c-2.9,0.7-5.9-1-6.6-3.9l0,0c-0.7-2.9,1-5.9,3.9-6.6l43.3-11.2c2.9-0.7,5.9,1,6.6,3.9l0,0 C420.2,561.3,418.4,564.2,415.5,565z"
});

var _ref60 =
/*#__PURE__*/
React.createElement("path", {
  d: "M331.6,536.1l-3.4-13.2c-0.1-0.4,0-0.8,0.3-1.1c0.3-0.3,0.7-0.4,1.1-0.3l13.1,3.7c0.4,0.1,0.7,0.4,0.8,0.8 c0.1,0.4,0,0.8-0.3,1.1l-9.8,9.6c-0.3,0.3-0.7,0.4-1.1,0.3C332,536.8,331.7,536.5,331.6,536.1z M330.9,524.2l2.4,9.4l6.9-6.8 L330.9,524.2z"
});

var _ref61 =
/*#__PURE__*/
React.createElement("g", {
  id: "_x32_OyNwC.tif_9_"
}, React.createElement("g", null, React.createElement("path", {
  d: "M280,521.5c-1.8,0.5-3.8,0.2-5.9-0.9c-0.4-0.2-0.9-0.5-1.2-0.8c-0.6-0.3-1.1-0.6-1.6-0.9c-1.9-0.9-4.2-0.3-5.4,1.5 c-0.4,0.5-0.7,1.2-1,1.8c-0.1,0.2-0.2,0.4-0.3,0.6c-1.2,2.3-2.9,3.8-4.8,4.3c-2,0.5-4.1,0.1-6.4-1.3c-0.3-0.2-0.5-0.3-0.8-0.5 c-0.5-0.3-1-0.6-1.5-0.9c-2-1-4.3-0.3-5.5,1.5c-0.3,0.5-0.6,1-0.9,1.6c-0.3,0.6-0.5,1.1-0.9,1.7c-2.1,3.5-5.9,4.6-9.6,2.8 c-0.7-0.4-1.3-0.7-1.9-1.1c-0.6-0.3-1.1-0.6-1.6-0.9c-1.3-0.6-1.9-2.2-1.3-3.5c0.6-1.3,2.2-1.9,3.5-1.3c0.8,0.4,1.4,0.8,2.1,1.1 c0.5,0.3,1,0.6,1.5,0.9c1.2,0.6,2.1,0.4,2.8-0.8c0.2-0.4,0.5-0.9,0.7-1.3c0.4-0.7,0.8-1.4,1.2-2.1c2.7-4,7.8-5.4,12.2-3.3 c0.8,0.3,1.4,0.8,2,1.1c0.2,0.1,0.5,0.3,0.6,0.4c1,0.6,1.8,0.9,2.3,0.7l0,0c0.5-0.2,1-0.7,1.6-1.7c0.1-0.2,0.2-0.4,0.3-0.6 c0.4-0.7,0.8-1.5,1.4-2.4c2.7-3.9,7.7-5.3,12-3.2c0.8,0.4,1.4,0.8,2.1,1.2c0.3,0.2,0.7,0.4,1.1,0.6c1.6,0.9,2.5,0.7,3.4-0.9 c0.2-0.3,0.3-0.6,0.5-0.9c0.4-0.9,0.9-1.9,1.9-2.9c1-1,2.6-1.2,3.7-0.2c1,1,1.2,2.6,0.2,3.7c-0.4,0.4-0.7,1-1,1.7 c-0.2,0.4-0.4,0.8-0.6,1.2C283.5,519.7,281.9,521,280,521.5z"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    version: 1.1,
    id: "Layer_1",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 768 850",
    style: {
      "enableBackground": "new 0 0 768 850"
    },
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61);
};

export default __webpack_public_path__ + "static/media/patterns.0efcc600.svg";
export { SvgComponent as ReactComponent };